import { useTheme } from '@mui/material/styles';
import AvailabilitySlotValue from '../common/AvailabilitySlotValue';
import TimelineBase from '../common/TimelineBase';

function TimeLinePaintball({
  times,
  slotMode,
  renderAvailableSlots,
  slotWidth = 140,
  showTimeRow,
  showSlotRows,
  hideTimeRow,
}) {
  const theme = useTheme();
  const slotBg =
    theme.palette.mode === 'light' ? theme.palette.grey[200] : theme.palette.grey[800];

  const renderSlotRows = ({ times }) => {
    if (slotMode) {
      const teams = [
        { id: 0, color: 'orange', name: 'Orange' },
        { id: 1, color: 'green', name: 'Green' },
        { id: 2, color: 'blue', name: 'Blue' },
        { id: 3, color: 'deeppink', name: 'Pink' },
      ];

      return (
        <>
          {teams.map((team, index) => (
            <div
              key={team.id}
              style={{
                display: 'flex',
                overflowX: 'visible',
                marginBottom: index === teams.length - 1 ? '10px' : '0px',
              }}
            >
              {times.map(time => (
                <div
                  key={time.i + `s${team.id}`}
                  style={{
                    minWidth: `${slotWidth}px`,
                    textAlign: 'left',
                    backgroundColor: team.color,
                    fontWeight: 'bold',
                  }}
                >
                  <AvailabilitySlotValue
                    count={time[`s${team.id}`]}
                    freeText={`${time[`frees${team.id}`]} frei`}
                    isWarning={time[`frees${team.id}`] < 0}
                    dense
                  />
                </div>
              ))}
            </div>
          ))}
        </>
      );
    }
    return (
      <div style={{ display: 'flex', overflowX: 'visible', marginBottom: '0px' }}>
        {times.map(time => (
          <div
            key={time.i + 's0'}
            style={{
              minWidth: `${slotWidth}px`,
              textAlign: 'left',
              backgroundColor: slotBg,
              fontWeight: 'bold',
              color: theme.palette.text.primary,
            }}
          >
            <AvailabilitySlotValue
              count={time.s0}
              freeText={`${time.frees0} frei`}
              isWarning={time.frees0 < 0}
              dense
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <TimelineBase
      times={times}
      slotWidth={slotWidth}
      renderSlotRows={renderSlotRows}
      renderAvailableSlots={renderAvailableSlots}
      showTimeRow={showTimeRow}
      showSlotRows={showSlotRows}
      hideTimeRow={hideTimeRow}
    />
  );
}

export default TimeLinePaintball;
